import React from 'react';
import { injectIntl } from 'react-intl';

import Tooltip from './Tooltip';

function ValidationTooltip({ intl, errors, ...props }) {
  return (
    <Tooltip {...props} data-validation="tooltip">
      {[].concat(...Object.values(errors)).map(error => {
        const msg = error.message || error;
        if (typeof msg === 'string') return msg;
        return intl.formatMessage(msg, msg.values || error.values);
      })}
    </Tooltip>
  );
}

export default injectIntl(ValidationTooltip);
